import { useCallback } from 'react';
import {
  ScratchpadRecommendation,
  ScratchpadRecommendationRequestType,
  useCreateScratchpadRecommendationMutation,
} from '../../../../../../../api/graphql/generated';
import { FlowItem } from '../../../../../shared/model/flow.types';
import { BeaconWeldingData } from '../../../model/beacon-welding-data';

type GetRecommendationForFormType = (
  form: FlowItem,
  config: BeaconWeldingData.FlowConfig
) => Promise<ScratchpadRecommendation | undefined>;

interface GetRecommendationForFormOptions {
  appSlug: string;
  recommendationType: ScratchpadRecommendationRequestType;
}

const useCreateRecommendationForForm = (
  options: GetRecommendationForFormOptions
): GetRecommendationForFormType => {
  const { appSlug, recommendationType } = options;
  const [createScratchpadRecommendation] =
    useCreateScratchpadRecommendationMutation();

  const createRecommendationForForm = useCallback(
    async (
      flowItem: FlowItem,
      flowConfig: BeaconWeldingData.FlowConfig
    ): Promise<ScratchpadRecommendation | undefined> => {
      // create a flow for the updated config
      const recommendation = await createScratchpadRecommendation({
        variables: {
          input: {
            appSlug,
            type: recommendationType,
            inputs: {
              flowItem,
              flowConfig,
            },
          },
        },
      });

      return recommendation.data?.createScratchpadRecommendation;
    },
    [appSlug, createScratchpadRecommendation, recommendationType]
  );

  return createRecommendationForForm;
};

export { useCreateRecommendationForForm };
